import React, { Component, createRef } from 'react';
import { Button, Icon, RadioGroup, Radio } from 'rsuite';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';
import BarcodeInput from './BarcodeInput';
import ColumnsInput from './ColumnsInput';
import GuestList from './GuestList';
import ContentLoader from '../ContentLoader';

class GuestSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBy: '',
      selectedColumn: '',
      barcodeInputRef: createRef(),
      columnsInputRef: createRef()
    };
  }

  static getDerivedStateFromProps({ searchBy, showBarcodeSearch }, state) {
    return { ...state, searchBy: showBarcodeSearch ? searchBy : 'columns' };
  }

  componentDidMount() {
    const { onInit } = this.props;
    onInit();
  }

  componentWillUnmount() {
    this.setState({
      searchBy: '',
      selectedColumn: '',
      barcodeInputRef: null,
      columnsInputRef: null
    });
  }

  handleSwitchSearchBy = searchBy => {
    const { onSwitchSearchBy } = this.props;
    onSwitchSearchBy(searchBy);
  };

  handleSwitchColumn = column => {
    this.setState({ selectedColumn: column });
  };

  handleSearchByColumns = query => {
    const { onChangeQuery, onSearchByColumns, paginationQuery } = this.props;
    onChangeQuery(query);
    if (!isEmpty(query)) onSearchByColumns({ ...paginationQuery, ...query });
    else onSearchByColumns(paginationQuery);
  };

  handleSearchByBarcode = ({ barcode }) => {
    const { onReset, onSearchByBarcode } = this.props;
    if (barcode) onSearchByBarcode(barcode);
    else onReset();
  };

  focusSearchByInput = () => {
    const { searchBy, barcodeInputRef, columnsInputRef } = this.state;
    if (searchBy === 'barcode' && barcodeInputRef.current)
      barcodeInputRef.current.focus();
    else if (searchBy === 'columns' && columnsInputRef.current)
      columnsInputRef.current.focus();
  };

  render() {
    const {
      defaultValue,
      hideCreate,
      columns,
      isFetching,
      showBarcodeSearch,
      onSelectGuest
    } = this.props;
    const {
      searchBy,
      selectedColumn,
      barcodeInputRef,
      columnsInputRef
    } = this.state;
    const isSearchByBarcode = searchBy === 'barcode';
    setTimeout(this.focusSearchByInput, 100);

    return (
      <div>
        {!hideCreate && (
          <Button
            onClick={() => {
              onSelectGuest(null);
            }}
            size="sm"
            appearance="ghost"
            style={{ float: 'right', marginBottom: 10 }}
          >
            <Icon icon="plus-circle" />
            &nbsp;
            <small>NEW GUEST</small>
          </Button>
        )}
        {showBarcodeSearch && (
          <RadioGroup
            inline
            name="searchBy"
            value={searchBy}
            onChange={this.handleSwitchSearchBy}
            style={{ paddingBottom: 6 }}
          >
            <Radio value="barcode" onFocus={this.handleBarcodeFocus}>
              <strong>Search By Barcode</strong>
            </Radio>

            <Radio value="columns">
              <strong>Search By Columns</strong>
            </Radio>
          </RadioGroup>
        )}
        {isSearchByBarcode ? (
          <BarcodeInput
            inputRef={barcodeInputRef}
            onSubmit={this.handleSearchByBarcode}
            onSwitchSearch={this.handleSwitchSearchBy}
            onGuestFound={onSelectGuest}
          />
        ) : (
          !isEmpty(columns) && (
            <ColumnsInput
              defaultValue={defaultValue}
              inputRef={columnsInputRef}
              columns={columns}
              onSubmit={this.handleSearchByColumns}
              onSwitchColumn={this.handleSwitchColumn}
              onSwitchSearch={this.handleSwitchSearchBy}
            />
          )
        )}
        {isSearchByBarcode ? (
          isFetching && <ContentLoader />
        ) : (
          <GuestList
            columns={columns}
            selectedColumn={selectedColumn}
            onSelectItem={onSelectGuest}
          />
        )}
      </div>
    );
  }
}

GuestSearch.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  searchBy: PropTypes.string,
  defaultValue: PropTypes.string,
  hideCreate: PropTypes.bool,
  isFetching: PropTypes.bool.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchQuery: PropTypes.shape({}).isRequired,
  paginationQuery: PropTypes.shape({}).isRequired,
  showBarcodeSearch: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onChangeQuery: PropTypes.func.isRequired,
  onSwitchSearchBy: PropTypes.func.isRequired,
  onSearchByBarcode: PropTypes.func.isRequired,
  onSearchByColumns: PropTypes.func.isRequired,
  onSelectGuest: PropTypes.func.isRequired
};

GuestSearch.defaultProps = {
  searchBy: 'barcode',
  defaultValue: '',
  hideCreate: false
};

export default GuestSearch;
